<template>
  <div class="Orders">
    <div id="reviews">
      <div class="review_card">
        <div class="row">
          <div class="col-md-2 user_info">
            <figure><img src="../assets/img/avatar4.jpg" alt="" /></figure>
            <h5>Lukas</h5>
          </div>
          <div class="col-md-10 review_content">
            <div class="clearfix add_bottom_15">
              <span class="rating"
                >8.5<small>/10</small> <strong>Rating average</strong></span
              >
              <em>Published 54 minutes ago</em>
            </div>
            <h4>"Great Location!!"</h4>
            <p>
              Eos tollit ancillae ea, lorem consulatu qui ne, eu eros eirmod
              scaevola sea. Et nec tantas accusamus salutatus, sit commodo
              veritus te, erat legere fabulas has ut. Rebum laudem cum ea, ius
              essent fuisset ut. Viderer petentium cu his. Tollit molestie
              suscipiantur his et.
            </p>
            <ul>
              <li>
                <a href="#0"><i class="icon_like"></i><span>Useful</span></a>
              </li>
              <li>
                <a href="#0"
                  ><i class="icon_dislike"></i><span>Not useful</span></a
                >
              </li>
              <li>
                <a href="#0"><i class="arrow_back"></i> <span>Reply</span></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /review_card -->
      <div class="review_card">
        <div class="row">
          <div class="col-md-2 user_info">
            <figure><img src="../assets/img/avatar6.jpg" alt="" /></figure>
            <h5>Lukas</h5>
          </div>
          <div class="col-md-10 review_content">
            <div class="clearfix add_bottom_15">
              <span class="rating"
                >8.5<small>/10</small> <strong>Rating average</strong></span
              >
              <em>Published 10 Oct. 2019</em>
            </div>
            <h4>"Awesome Experience"</h4>
            <p>
              Eos tollit ancillae ea, lorem consulatu qui ne, eu eros eirmod
              scaevola sea. Et nec tantas accusamus salutatus, sit commodo
              veritus te, erat legere fabulas has ut. Rebum laudem cum ea, ius
              essent fuisset ut. Viderer petentium cu his. Tollit molestie
              suscipiantur his et.
            </p>
            <ul>
              <li>
                <a href="#0"><i class="icon_like"></i><span>Useful</span></a>
              </li>
              <li>
                <a href="#0"
                  ><i class="icon_dislike"></i><span>Not useful</span></a
                >
              </li>
              <li>
                <a href="#0"><i class="arrow_back"></i> <span>Reply</span></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /review_card -->
      <div class="review_card">
        <div class="row">
          <div class="col-md-2 user_info">
            <figure><img src="../assets/img/avatar1.jpg" alt="" /></figure>
            <h5>Marika</h5>
          </div>
          <div class="col-md-10 review_content">
            <div class="clearfix add_bottom_15">
              <span class="rating"
                >9.0<small>/10</small> <strong>Rating average</strong></span
              >
              <em>Published 11 Oct. 2019</em>
            </div>
            <h4>"Really great dinner!!"</h4>
            <p>
              Eos tollit ancillae ea, lorem consulatu qui ne, eu eros eirmod
              scaevola sea. Et nec tantas accusamus salutatus, sit commodo
              veritus te, erat legere fabulas has ut. Rebum laudem cum ea, ius
              essent fuisset ut. Viderer petentium cu his. Tollit molestie
              suscipiantur his et.
            </p>
            <ul>
              <li>
                <a href="#0"><i class="icon_like"></i><span>Useful</span></a>
              </li>
              <li>
                <a href="#0"
                  ><i class="icon_dislike"></i><span>Not useful</span></a
                >
              </li>
              <li>
                <a href="#0"><i class="arrow_back"></i> <span>Reply</span></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /row -->
        <div class="row reply">
          <div class="col-md-2 user_info">
            <figure><img src="../assets/img/avatar.jpg" alt="" /></figure>
          </div>
          <div class="col-md-10">
            <div class="review_content">
              <strong>Reply from Foogra</strong>
              <em>Published 3 minutes ago</em>
              <p>
                <br />Hi Monika,<br /><br />Eos tollit ancillae ea, lorem
                consulatu qui ne, eu eros eirmod scaevola sea. Et nec tantas
                accusamus salutatus, sit commodo veritus te, erat legere fabulas
                has ut. Rebum laudem cum ea, ius essent fuisset ut. Viderer
                petentium cu his. Tollit molestie suscipiantur his et.<br /><br />Thanks
              </p>
            </div>
          </div>
        </div>
        <!-- /reply -->
      </div>
      <!-- /review_card -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Orders",
};
</script>
